import tokens from '@lansforsakringar/core-tokens'
import { css } from 'lit'

import { vars, scoped, declare, override } from '#utils/styles'

const locals = scoped('input', [
	'background_color',
	'border_radius',
	'border_color',
	'padding',
	'height',
	'color'
] as const)

export default css`
	:host {
		${declare(locals, {
			background_color: tokens.color_background_secondary,
			border_radius: tokens.border_radius_xs,
			border_color: tokens.color_border_focus,
			padding: tokens.spacing_sm,
			height: tokens.spacing_4xl,
			color: tokens.color_text_primary
		})};

		display: flex;
		width: 100%;
		flex-direction: column;
		color: ${vars(locals.color)};
	}

	.label {
		font-size: ${vars(tokens.text_size_label_default)};
		font-weight: ${vars(tokens.font_weight_semibold)};
		line-height: ${vars(tokens.line_height_label_default)};
		text-wrap: balance;
	}

	.box {
		display: flex;
		align-items: center;
		overflow: hidden;
		background: ${vars(locals.background_color)};
		border-radius: ${vars(locals.border_radius)};
		border: 1px solid;
		color: ${vars(locals.color)};
		border-color: ${vars(locals.border_color)};
		transition: 125ms var(--ease-in);
		transition-property: box-shadow, border-color;

		/* Make the border gray when it's empty */
		&:has(.input:where(:placeholder-shown)) {
			${override(locals.border_color, tokens.color_border_tertiary)};
		}

		&:has(.input:where(:-webkit-autofill, :autofill)) {
			background: ${vars(tokens.color_background_highlight_primary)};
		}

		/* Focus and hover state */
		&:has(.input:where(:hover, :focus)) {
			${override(locals.border_color, tokens.color_border_focus)};

			box-shadow: inset 0 0 0 1px ${vars(locals.border_color)};
			transition-timing-function: var(--ease-out);
			outline: 0;
		}

		&.focus-visible:has(.input:focus-visible) {
			outline: var(--focus-outline);
			outline-offset: var(--focus-outline-offset);
		}

		/* Invalid state */
		&.invalid {
			${override(locals.border_color, tokens.color_border_error)};
		}
	}

	.affix {
		line-height: calc(21 / 16);
		padding-inline: ${vars(locals.padding)};
		font-size: 1rem;
		font-weight: 600;
		cursor: text;
		color: inherit;
		user-select: none;

		&.prefix {
			padding-inline-end: 0;
		}

		&.suffix {
			padding-inline-start: 0;
		}
	}

	.input {
		flex: 1;
		padding: 0 ${vars(locals.padding)};
		height: ${vars(locals.height)};
		border: none;
		font-size: 1rem;
		line-height: calc(21 / 16);
		caret-color: ${vars(tokens.color_border_focus)};
		color: inherit;
		appearance: none;
		background: transparent;

		&:focus {
			outline: none;
		}
	}

	.input::-webkit-outer-spin-button,
	.input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	.input:is(:-webkit-autofill, :autofill) {
		background: transparent !important;
		color: inherit !important;
	}

	.header {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		gap: ${vars(tokens.spacing_sm)};
		color: ${vars(tokens.color_text_primary)};
		padding-block-end: ${vars(tokens.spacing_xs)};

		.header-text {
			display: flex;
			flex-direction: column;
		}
	}

	.help {
		cursor: default;
		font-size: ${vars(tokens.text_size_caption_default)};
		line-height: ${vars(tokens.line_height_caption_default)};
		color: ${vars(tokens.color_text_secondary)};

		&.counter {
			user-select: none;
		}

		&.warning {
			color: ${vars(tokens.color_text_error)};
		}
	}

	.validation {
		display: flex;
		align-items: flex-start;
		padding-block-start: ${vars(tokens.spacing_xs)};
		cursor: default;
		gap: ${vars(tokens.spacing_xs)};
		color: ${vars(tokens.color_text_error)};
		line-height: calc(18 / 14);
		font-size: 0.875rem;

		.icon {
			margin: -0.2rem 0 0 -0.15rem;
		}
	}
`
